import { API_INSTANCE } from 'src/features/utils';
import { store } from 'src/store';
import { setCurrentModalAction } from 'src/redesign/features/Modals/store/reducer';
import { CONNECTED_MODALS } from 'src/redesign/features/Modals/store/constants';

/**
 * Setup axios interceptor to detect trial order limit errors
 * and show the TrialOrderLimitModal
 */
export const setupTrialLimitInterceptor = () => {
  API_INSTANCE.interceptors.response.use(
    (response) => response,
    (error) => {
      // Check for trial order limit error
      const errorData = error?.response?.data;
      const errorMessage = errorData?.error || error?.message || '';

      // Check if this is a trial order limit error
      const isTrialLimitError =
        errorMessage.includes('trial is limited to 10 orders') ||
        errorMessage.includes('Trial order limit') ||
        errorMessage.includes('free trial is limited to');

      if (isTrialLimitError) {
        // Show the modal with order count and limit if available
        store.dispatch(
          setCurrentModalAction({
            currentModal: CONNECTED_MODALS.TRIAL_ORDER_LIMIT_MODAL,
            data: {
              title: 'Trial Order Limit Reached',
              orderCount: errorData?.orderCount || 10,
              limit: errorData?.limit || 10,
            },
            visible: true,
          }),
        );
      }

      // Re-throw the error so it can still be handled by the caller
      return Promise.reject(error);
    },
  );
};
